import { defaultState } from "./types";
import { MainInterface } from "./components/MainInterface";
import { OperationSelection } from "./components/OperationSelection";
import { reducer, WelderContext } from "./reducer";
import { useReducer } from "react";
import { WeldSelection } from "./components/WeldSelection";
import { usePageStateGuard } from "@/hooks";

export function HitachiWelderRole() {
  const [state, updateState] = useReducer(reducer, defaultState);
  const currentPage = usePageStateGuard({
    2: Boolean(state.operation),
    3: Boolean(state.operation) && state.welds.length > 0,
  });

  return (
    <WelderContext.Provider value={{ state, updateState }}>
      {currentPage === 1 && <OperationSelection />}
      {currentPage === 2 && <WeldSelection />}
      {currentPage === 3 && <MainInterface />}
    </WelderContext.Provider>
  );
}
